module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-pro@2x.1fb2c9a2.png" + "?" + Date.now();